export const SHOWED_INT_MODAL = 'showed_int_modal';
export const CURRENT_LANGUAGE = 'current_language';
export const CURRENT_MRO = 'current_mro';

export const ACCESS_TOKEN = 'hilbi_access_token';
export const REFRESH_TOKEN = 'hilbi_refresh_token';
